var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginRequired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5825_5982)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 40.5,
    r: 25.5,
    fill: "#E1E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 22.25L40.5835 29.5L33.3335 36.75",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22.25L28.5 29.5L21.25 36.75",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.5L6.75 29.5",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 12.5833L23.6667 10.1667C23.6667 9.52573 23.9213 8.91104 24.3745 8.45782C24.8277 8.00461 25.4424 7.75 26.0833 7.75L47.8333 7.75C48.4743 7.75 49.089 8.00461 49.5422 8.45783C49.9954 8.91104 50.25 9.52573 50.25 10.1667L50.25 48.8333C50.25 49.4743 49.9954 50.089 49.5422 50.5422C49.089 50.9954 48.4743 51.25 47.8333 51.25L26.0833 51.25C25.4424 51.25 24.8277 50.9954 24.3745 50.5422C23.9213 50.089 23.6667 49.4743 23.6667 48.8333L23.6667 46.4167",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5825_5982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRequired);
export default __webpack_public_path__ + "static/media/loginRequired.8ca3aaf56155fb51185efc0b852b3d9a.svg";
export { ForwardRef as ReactComponent };